import { Button, Modal, ThemeOverride } from "@modernatx-internal/ui-kit-react";
import React from "react";

import { ModalButtonProps } from "@/types/Block";

export const ModalButtonContext = React.createContext<{ closeModal: () => void } | undefined>(
  undefined
);

const ModalButton: React.FC<React.PropsWithChildren<ModalButtonProps>> = ({
  buttonProps,
  modalSize,
  themeOverrideMode,
  children
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const closeModal = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const modalContent = (
    <Modal isOpen={isModalOpen} size={modalSize} onDismiss={closeModal}>
      <ModalButtonContext.Provider value={{ closeModal }}>{children}</ModalButtonContext.Provider>
    </Modal>
  );

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)} {...buttonProps} />
      {themeOverrideMode ? (
        <ThemeOverride mode={themeOverrideMode}>{modalContent}</ThemeOverride>
      ) : (
        modalContent
      )}
    </>
  );
};

export default ModalButton;
